import { User } from '../../../../@types/users';
import { DriverIcon, EditIcon } from '../../../../assets/svgs';
import { COLORS } from '../../../../consts/colors';
import { formatDateTime } from '../../../../utils/time';
import {
  Content,
  Wrapper,
  TitleRow,
  StatusIcon,
  RoleBadge,
  DriverIconWrapper,
  LastActivity,
  DateTimeValue,
  EditIconWrapper,
} from './style';

type UserListItemProps = {
  user: User;
  onClick: () => void;
};

export const UserListItem = ({ user, onClick }: UserListItemProps) => {
  const isOnline = () => {
    const lastActivitySeconds = user.lastActivityTime ? user.lastActivityTime.getTime() : 0;
    const nowSeconds = new Date().getTime();

    return lastActivitySeconds >= nowSeconds - 30 * 1000;
  };

  const isVolunteer = user.role?.name === 'מתנדב' || String(user.role?.id) === '5';

  return (
    <Wrapper onClick={onClick}>
      <StatusIcon isOnline={isOnline()} hasUsername={Boolean(user.username)} />
      <Content>
        <TitleRow>
          {user.firstName} {user.lastName}
          {user.isDriver && (
            <DriverIconWrapper title="נהג">
              <DriverIcon width={20} height={20} fill={COLORS.LIGHT_BLUE} />
            </DriverIconWrapper>
          )}
        </TitleRow>
        {user.lastActivityTime && (
          <LastActivity>
            פעילות אחרונה:
            <DateTimeValue>{formatDateTime(user.lastActivityTime)}</DateTimeValue>
          </LastActivity>
        )}
      </Content>
      {!isVolunteer && user.role?.name && <RoleBadge>{user.role.name}</RoleBadge>}
      <EditIconWrapper title="עריכת משתמש">
        <EditIcon style={{ fill: COLORS.DARKER_GRAY }} width={20} height={20} />
      </EditIconWrapper>
    </Wrapper>
  );
};
